import styled from "styled-components";
import Col from "../../UIcomponent/Column";
import StyledAvatar from "../../UIcomponent/StyledAvatar";
import StyledButton from "../../UIcomponent/Button";

export const Layout = styled(Col)`
  /* border: 1px solid red; */
  height: auto;
  flex-direction: column;
  justify-content: flex-start;
`;

export const Container = styled(Col)`
  flex-direction: column;
  justify-content: flex-start;
  background-color: white;
  min-height: 550px;
  height: auto;
  margin: 100px 0px 50px 0px;
  border-radius: ${(props) => props.theme.radiusMd};
  box-shadow: ${(props) => props.theme.shadow};
  padding: 15px;
`;

export const StatusText = styled(Col)`
  font-size: ${(props) => props.theme.fontSizeXl};
  color: ${(props) =>
    props.payStatus === 1 ? props.theme.secondary : props.theme.danger};
  margin: 35px 0px 35px 0px;
  font-weight: 800;
`;
export const HSeperator = styled(Col)`
  background-color: ${(props) => props.color || props.theme.lightGray};
  height: ${(props) => props.height || "1px"};
  width: ${(props) => props.width || "100%"};
  border-radius: 50px;
`;
export const Avatar = styled(StyledAvatar)`
  width: 110px;
  height: 110px;
  border-radius: 70px;
  margin: 25px 0px 0px 0px;
`;
export const Title = styled(Col)`
  font-size: ${(props) => props.theme.fontSizeLg};
  font-weight: 800;
  height: 35px;
  margin: 15px 0px 15px 0px;
  @media screen and (max-width: 768px) {
    font-size: 0.9em;
  }
`;
export const Text = styled(Col)`
  color: ${(props) => props.color || props.theme.textLight};
  font-size: ${(props) => props.fontSizelg || props.theme.fontSizeLg};
  margin: 15px 0px 15px 0px;
  a {
    width: auto;
    padding: 0px 5px 0px 5px;
    text-decoration: none;
    color: ${(props) => props.theme.primary};
  }
  @media screen and (max-width: 768px) {
    display: inline-block;
    font-size: ${(props) => props.fontSizeSm || props.theme.fontSizeLg};
    flex-wrap: wrap;
    line-height: 30px;
  }
`;
export const SessionContainer = styled(Col)`
  flex-direction: column;
  flex-wrap: wrap;
  height: auto;
  max-height: 220px;
  margin-top: -10px;
  @media screen and (max-width: 992px) {
    max-height: 440px;
    /* flex-wrap: nowrap; */
    /* overflow: scroll; */
    /* justify-content: flex-start; */
  }
  @media screen and (max-width: 768px) {
    max-height: 220px;
    flex-wrap: nowrap;
    overflow: scroll;
    justify-content: flex-start;
  }
`;
export const Session = styled(Col)`
  color: ${(props) => props.color || props.theme.textLight};
  font-size: ${(props) => props.fontSize || props.theme.fontSizeMd};
  justify-content: space-around;
  height: 40px;
  min-height: 40px;
  margin-bottom: 4px;
  /* border-bottom: ${(props) =>
    `2px solid ${
      props.payStatus === 1 ? props.theme.secondary : props.theme.danger
    }`}; */
  div:nth-of-type(1) {
    color: ${(props) => props.color || props.theme.textLight};
    justify-content: flex-start;
    width: 65%;
  }
  div:nth-of-type(2) {
    color: ${(props) => props.color || props.theme.textLight};
    justify-content: flex-end;
    width: 35%;
  }
`;
export const PriceInfo = styled(Col)`
  display: ${(props) => props.payStatus === 1 && "none"};
  color: ${(props) => props.color || props.theme.textBold};
  font-size: ${(props) => props.fontSize || props.theme.fontSizeMd};
  justify-content: space-around;
  height: 40px;
  min-height: 40px;
  margin-top: 25px;
  width: 240px;
  font-weight: 800;
  div:nth-of-type(1) {
    justify-content: flex-start;
    width: 45%;
  }
  div:nth-of-type(2) {
    justify-content: flex-end;
    width: 55%;
  }
`;
export const ActionConatiner = styled(Col)`
  justify-content: space-evenly;
  margin: ${(props) =>
    props.payStatus === -1 ? "5px 0px 25px 0px" : "25px 0px 25px 0px"};
  @media screen and (max-width: 768px) {
    flex-direction: ${(props) => props.payStatus === 1 && "column"};
    margin: ${(props) =>
      props.payStatus === -1 ? "5px 0px 25px 0px" : "5px 0px 5px 0px"};
    height: ${(props) => props.payStatus === 1 && "120px"};
  }
`;
export const ActionButton = styled(StyledButton)`
  height: 40px;
  width: ${(props) => props.width || "160px"};
  a {
    font-size: ${(props) => props.theme.fontSizeLg};
    color: ${(props) => props.color || "white"};
  }
`;
